import React from 'react';
import { MenuItem } from '@mui/material';
import IndividualTile from './IndividualTile';

interface TileListProps {
  tiles: any[];
  reOrderTileList: (tabId:number, moveAction: string, moveItemInd: number) => void;
  tileState: any;
  tabTileProps: any;
  handleClose?: () => void;
  handleRenameTileBegin: (tabId: number, tileId: number) => void;
  handleRenameTileComplete: (renameValue: string, tabId: number, tileId: number) => void;
  handleSelectTile: (tileId: number, tileName: string, tabId: number, tabName: string) => void;
  handleRemoveTile: (tabId: number, tileId: number) => void;
  inPopup?: boolean;
  childRef?: React.RefObject<HTMLDivElement>;
  tileListOpen?: boolean;
  MaxTiles: number;
  tabAreaBackgroundColor?: string;
  iconColor?: string;
  selectedTabBackgroundColor?: string;
}

const TileList: React.FC<TileListProps> = ({
  tiles,
  tileState,
  tabTileProps,
  reOrderTileList,
  handleClose,
  handleRenameTileBegin,
  handleRenameTileComplete,
  handleSelectTile,
  handleRemoveTile,
  tabAreaBackgroundColor,
  iconColor,
  selectedTabBackgroundColor,
  inPopup = false,
  MaxTiles,
  childRef,
  tileListOpen,
}) => {
  const renderTiles = tiles.map((tile: number, tileIndex) => {
    const currentObj = tileState.tiles[tile];

    const otherTileNames = tiles
      .filter((id) => id !== tile)
      .map((id) => tileState.tiles[id]?.tileName?.toLowerCase())
      .filter(Boolean) as string[];

    const tileComponent = (
      <IndividualTile
        totalTile={tiles?.length}
        tileIndex={tileIndex}
        key={currentObj.tileId}
        tabName={currentObj.tabName}
        tileName={currentObj.tileName}
        editing={tabTileProps.editTileName}
        editingTileId={tabTileProps.editingTileId}
        selectedTile={tabTileProps.selectedTileId}
        tabId={currentObj.tabId}
        tileId={currentObj.tileId}
        showDash={tabTileProps.showDash}
        reOrderTileList={reOrderTileList}
        renameTileBegin={handleRenameTileBegin}
        renameTileComplete={handleRenameTileComplete}
        selectTile={handleSelectTile}
        removeTile={handleRemoveTile}
        tabAreaBackgroundColor={tabAreaBackgroundColor}
        iconColor={iconColor}
        selectedTabBackgroundColor={selectedTabBackgroundColor}
        MaxTiles={MaxTiles}
        otherTileNames={otherTileNames}
      />
    );

    return inPopup ? (
      <MenuItem
        key={tileIndex}
        onClick={handleClose}
        style={{
          width: '100%',
          margin: '0px',
          padding: '0px',
          height: '35px',
          backgroundColor: 'transparent',
        }}
      >
        {React.cloneElement(tileComponent, {
          popupClass: 'popupTile',
          inPopup: true,
          tileListOpen,
        })}
      </MenuItem>
    ) : (
      tileComponent
    );
  });

  // Wrap all tiles in a div with the ref
  return (
    <div ref={childRef} style={{ display: `${inPopup ? 'block' : 'flex'}` }}>
      {renderTiles}
    </div>
  );
};

export default TileList;
